<template>
  <div class="contact">
    <img class="contact_wx" src="@/assets/images/contact_wx.png" alt="" />
    <p class="contact_wx_text">微信客服</p>
    <img class="contact_phone" src="@/assets/images/contact_phone.gif" alt="" />
    <span class="contact_phone_text">400-025-6889</span>
    <p class="contact_phone_text">电话客服</p>
  </div>
</template>

<script setup></script>

<style scoped lang="scss">
.contact {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 20px;
  border-radius: 10px;
  background-color: #fff;
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1);
  position: fixed;
  right: 30px;
  top: 65%;
  transform: translateY(-50%);
  z-index: 9999;
  &_wx_text {
    font-size: 14px;
    color: #333;
    margin-top: 10px;
    margin-bottom: 20px;
  }
  &_phone_text {
    font-size: 14px;
    color: #333;
    margin-top: 10px;
  }
  &_wx {
    width: 100px;
    height: 100px;
  }
  &_phone {
    width: 50px;
    height: 50px;
  }
}
</style>
